// Tipo para los diferentes tipos de límites
export type FeatureType =
  | "employees"
  | "warehouses"
  | "boxes"
  | "inventory"
  | "marketing";

// Interfaz para los mensajes de un plan específico
export interface PlanMessages {
  Emprendedor: string;
  Estándar?: string;
}

// Interfaz para los mensajes de todos los tipos de límites
export interface FeatureMessages {
  employees: PlanMessages;
  warehouses: PlanMessages;
  boxes: PlanMessages;
  inventory: PlanMessages;
  marketing: PlanMessages;
}

// Constante con todos los mensajes organizados por tipo de límite y plan
export const featureMessages: FeatureMessages = {
  employees: {
    Emprendedor:
      "El plan <b>{accountInfo.plan.name}</b> permite hasta <b>{counter}</b> usuarios. Cambia al plan <b>Estándar</b> para sumar más personas a tu equipo y seguir creciendo.",
    Estándar:
      "El plan <b>{accountInfo.plan.name}</b> permite hasta <b>{counter}</b> usuarios. Cambia al plan <b>Pro</b> para sumar más personas a tu equipo y seguir creciendo.",
  },
  warehouses: {
    Emprendedor:
      "El plan <b>{accountInfo.plan.name}</b> permite hasta <b>{counter}</b> almacenes. Pásate al plan <b>Estándar</b> para gestionar múltiples almacenes y optimizar la gestión de tus productos.",
    Estándar:
      "El plan <b>{accountInfo.plan.name}</b> permite hasta <b>{counter}</b> almacenes. Pásate al plan <b>Pro</b> para gestionar múltiples almacenes y optimizar la gestión de tus productos.",
  },
  boxes: {
    Emprendedor:
      "Para agregar más de una caja, necesitas cambiarte al plan <b>Estándar</b>. Mejora tu plan y disfruta de esta y otras ventajas.",
  },
  inventory: {
    Emprendedor:
      "Realizar inventario de productos es una funcionalidad del plan <b>Estándar</b>. Cámbiate de plan para llevar un mejor control de tu stock.",
  },
  marketing: {
    Emprendedor:
      "El módulo de marketing es una funcionalidad del plan <b>Estándar</b>. Mejora tu plan y disfruta de esta y otras ventajas.",
  },
};
